module.exports = __webpack_public_path__ + "img/helicopter.a20a7137.gif";